import React, { useEffect } from 'react';
import { Layout, Row, Col, Table, Card, Spin } from 'antd';
import { withAsyncActions } from 'react-async-client';

import { getProductList } from 'actions/asyncActions';

import RouteTitle from 'components/pages/RouteTitle.js';
import Breakpoint from 'components/layout/Breakpoint.js';
import { mapIndexed } from 'utils/ramdaAdditions.js';

function TableCardProject(product) {

    return (
        <Card className="table-card" key={product.id}>
            <Row type="flex" justify="space-between">
                <p>Серия</p>
                <div className="table-actions">
                    {product.series}
                </div>
            </Row>
            <Row className="bold m-t-10">
                <p>Сайт</p>
                <a href={product.site} className="product-list__link">{product.site}</a>
            </Row>
            <Row className="bold m-t-10">
                <p>Каталог</p>
                <a href={product.catalog} className="product-list__link">{product.catalog}</a>
            </Row>
            <Row className="key m-t-20" type="flex" justify="space-between">
                <p>Cashback</p>
                <div className="table-actions">
                    {product.cache_back + ' %'}
                </div>
            </Row>
        </Card>
    )
}

const columns = [
    {
        title: 'Серия',
        dataIndex: 'series',
        key: 'series',
        className: 'bold',
    },
    {
        title: 'Сайт',
        dataIndex: 'site',
        key: 'site',
        render: link=> <a href={link} target="_blank" className="product-list__link">{link}</a>
    },
    {
        title: 'Каталог',
        dataIndex: 'catalog',
        key: 'catalog',
        render: link=> <a href={link} target="_blank" className="product-list__link">{link}</a>
    },
    {
        title: 'Cashback',
        dataIndex: 'cache_back',
        key: 'cache_back',
        render: cache_back=> cache_back + ' %'
    },
];

const ProductList = ({ getProductList }) => {

    useEffect(()=> {
        getProductList.dispatch()
    }, [])

    const { data: { data=[] }, meta } = getProductList

    return (
        <Layout className="product-list page main-content">
            <Breakpoint min="lg">
                <RouteTitle className="title-route title-page" />
            </Breakpoint>

             <Row>
                <Col lg={24} md={24} sm={24} xs={24}>
                    <Breakpoint min="sm">
                        <Table
                            rowKey="id"
                            columns={columns}
                            loading={meta.pending}
                            dataSource={data}
                            pagination={false}
                        />
                    </Breakpoint>
                </Col>
            </Row>
            <Breakpoint max="sm">
                {meta.pending && <Spin style={{transform: "translateY(150px)"}}/>}
                {mapIndexed(TableCardProject, data)}
            </Breakpoint>
        </Layout>
    );
}

const propsToAction = () => ({ getProductList: getProductList.withPayload(props=> props)})
export const Products = withAsyncActions(propsToAction)(ProductList)


// WEBPACK FOOTER //
// ./src/components/pages/products/Products.js